import { safeSessionStorage } from "@/utils/safeStorage";

const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
})();

const isPreviewHost =
  window.location.hostname.includes("id-preview--") ||
  window.location.hostname.includes("lovableproject.com");

export const registerServiceWorker = () => {
  if (!("serviceWorker" in navigator)) return;

  // In preview/iframe contexts, unregister any stale SWs and bail.
  if (isPreviewHost || isInIframe) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
    return;
  }

  // Temporary production recovery: only update existing app-shell service workers.
  // Users with stale phone/PWA caches receive the cleanup worker at /sw.js; fresh
  // browsers are not registered into an app-shell SW loop.
  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading || safeSessionStorage.getItem("__gb_sw_cleanup_reload")) return;
    reloading = true;
    safeSessionStorage.setItem("__gb_sw_cleanup_reload", "1");
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      const appShellRegistrations = registrations.filter((registration) => {
        const scriptURL = registration.active?.scriptURL || registration.waiting?.scriptURL || registration.installing?.scriptURL || "";
        return scriptURL.endsWith("/sw.js") || registration.scope === `${window.location.origin}/`;
      });

      if (appShellRegistrations.length === 0) return;

      navigator.serviceWorker
        .register("/sw.js")
        .then((registration) => {
        // If a worker is already waiting when we register, prompt immediately.
        if (registration.waiting && navigator.serviceWorker.controller) {
          registration.waiting.postMessage("skipWaiting");
        }

        // When an update is found, watch for it to finish installing.
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              newWorker.postMessage("skipWaiting");
            }
          });
        });

        // Proactively check once so stale mobile registrations see the cleanup.
        registration.update().catch(() => {});
        })
        .catch((err) => {
          console.log("SW cleanup registration failed: ", err);
        });
    });
  });
};
